/* eslint no-param-reassign: 0 */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { push as pushAction } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { isEqual, cloneDeep, forEach } from 'lodash';
import queryString from 'query-string';
import utils from '@utils';
import Actions from '@redux/reports';
import { getNewJobStatus } from '@config/utils';
import ReportsTable from './reportsTable';
import { paymentReportsColumn, reportsJobColumn } from '../utils/columnsDefinition';

class PaymentHistoryReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rateStats : this.processRateStatusData(props.reportData || []),
			jobData   : this.processJobData(props.reportData.JobPaymentSummaries || []),
		};
	}

	UNSAFE_componentWillReceiveProps = ({ reportData }) => {
		const lastProps = this.props;
		if (!isEqual(lastProps.reportData, reportData)) {
			this.setState({
				rateStats : this.processRateStatusData(reportData || []),
				jobData   : this.processJobData(reportData.JobPaymentSummaries || []),
			});
		}
	}

	componentWillUnmount = () => {
		const { resetReportsListData } = this.props;
		resetReportsListData();
	}

	shouldComponentUpdate = ({ reportData, filterPrintData }, { rateStats, jobData }) => {
		const lastProps = this.props;
		const lastState = this.state;
		return (
			!isEqual(lastProps.reportData, reportData)
			|| !isEqual(lastProps.filterPrintData, filterPrintData)
			|| !isEqual(lastState.rateStats, rateStats)
			|| !isEqual(lastState.jobData, jobData)
		);
	}

	processRateStatusData = (rawData) => (
		[
			{
				id    : 1,
				label : 'Total Paid',
				value : rawData.TotalPaid,
			},
			{
				id    : 2,
				label : 'Total Paid to Officers',
				value : rawData.TotalPaidToOfficers,
			},
			{
				id    : 3,
				label : 'Total Paid to Coordinators',
				value : rawData.TotalPaidToCoordinators,
			},
		]);

	processJobData = (rawJobData) => {
		const jobSummary = cloneDeep(rawJobData);
		if (jobSummary.length) {
			forEach(jobSummary, (item) => {
				item.statusObj = getNewJobStatus(item);
			});
		}
		return jobSummary;
	}

	invoiceIdClicked = ({ InvoiceStatusId, InvoiceId }) => {
		const { push } = this.props;
		let type;
		switch (InvoiceStatusId) {
			case 1:
			case 2:
			case 3:
				type = 'review';
				break;
			case 4:
			case 5:
				type = 'payments';
				break;
			case 6:
				type = 'paid';
				break;
			case 7:
				type = 'payments';
				break;
			case 8:
				type = 'disputes';
				break;
			case 9:
				type = 'paid';
				break;
			default:
				type = 'payments';
		}
		push({ pathname : `/payments/${InvoiceId}`, search : queryString.stringify({ type, fromReports : true }) });
	}

	transactionIdClicked = ({ InvoiceStatusId, TransactionId }) => {
		const { push } = this.props;
		if (InvoiceStatusId && TransactionId) push({ pathname : `/payments/receipt/${TransactionId}` });
	}

	renderRateStats = (rateStats) => (
		<Fragment>
			<Row className="padding-top-20 hidden-print">
				<For
					each="item"
					of={rateStats}
				>
					<Col
						key={item.id}
						md={4}
						xs={6}
						className="height-100"
					>
						<div className="bg-white padding-15 rate-stats-upper-border rate-stats-bottom-border">
							<span className="rate-stats-label">{ item.label }</span>
							<p className="rate-stats-value">{ utils.currencyFormatter(item.value) }</p>
						</div>
					</Col>
				</For>
			</Row>
			<Row className="show-print margin-left-1">
				<div className="margin-top-10">
					<span className="color-dark font-regular report-table-header-title">Payment summary</span>
				</div>
				<For
					each="item"
					of={rateStats}
				>
					<div
						key={item.id}
						className="flex"
					>
						<span className="font-light color-gray-bayoux flex-1">{ item.label }</span>
						<span className="font-regular color-gray-bayoux flex-2">
							:
							{ utils.currencyFormatter(item.value) }
						</span>
					</div>
				</For>
			</Row>
		</Fragment>
	)

	showFilterDataForPrint = (filterPrintData) => (
		<Fragment>
			<div className="margin-top-10">
				<span className="color-dark font-regular report-table-header-title">Filters</span>
			</div>
			<Choose>
				<When condition={filterPrintData.length}>
					<For
						each="item"
						of={filterPrintData}
					>
						<div
							key={item.label}
							className="flex"
						>
							<span className="font-light color-gray-bayoux flex-1">{ item.label }</span>
							<span className="font-regular color-gray-bayoux flex-2">
								:
								{ item.value }
							</span>
						</div>
					</For>
				</When>
				<Otherwise>
					<span>No filter Applied</span>
				</Otherwise>
			</Choose>
		</Fragment>
	);

	render() {
		const { rateStats, jobData } = this.state;
		const { reportData, filterPrintData, TimeZoneId } = this.props;
		return (
			<Fragment>
				<h3 className="font-size-24 font-regular color-gray-oxford">Payment History Report</h3>
				<div className="show-print">
					{ this.showFilterDataForPrint(filterPrintData) }
				</div>
				{ this.renderRateStats(rateStats) }
				<ReportsTable
					header="Officer Payment Summary"
					data={reportData.OfficerPaymentSummaries || []}
					tableColumn={paymentReportsColumn('Officer')}
				/>
				<ReportsTable
					header="Coordinator Payment Summary"
					data={reportData.CoordinatorsPaymentSummaries || []}
					tableColumn={paymentReportsColumn('Coordinator')}
				/>
				<ReportsTable
					header="Location Payment Summary"
					data={reportData.LocationPaymentSummaries || []}
					tableColumn={paymentReportsColumn('Location')}
				/>
				<ReportsTable
					header="Invoice Payment Summary"
					data={jobData}
					tableColumn={reportsJobColumn('paymentHistory', this.invoiceIdClicked, this.transactionIdClicked, TimeZoneId)}
				/>
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	reports : {
		reportData,
		filterPrintData,
	}, app: { user: { TimeZoneId } },
}) => ({
	reportData,
	filterPrintData,
	TimeZoneId,
});

const mapDispatchToProps = (dispatch) => ({
	push                 : bindActionCreators(pushAction, dispatch),
	resetReportsListData : bindActionCreators(Actions, dispatch).resetReportsListData,
});

PaymentHistoryReport.propTypes = {
	TimeZoneId           : PropTypes.string,
	filterPrintData      : PropTypes.array,
	push                 : PropTypes.func.isRequired,
	reportData           : PropTypes.object,
	resetReportsListData : PropTypes.func.isRequired,
};

PaymentHistoryReport.defaultProps = {
	TimeZoneId      : '',
	filterPrintData : [],
	reportData      : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentHistoryReport);
